import React, { useEffect, useState } from "react";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import Table from "../../components/common/table/Table";
import activeIcon from "../../assets/svg/active-user.svg";
import inactiveIcon from "../../assets/svg/inactive-user.svg";
import { masterActions } from "./../../_store/master.slice";
import { useDispatch, useSelector } from "react-redux";
import { logReportAction } from "../../_store";
import { fDate, MinDate, Today } from "../../utils/formatTime";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import generateXlsx from "../../components/common/export/generateXlsx";
import { formatDateTimeAMPM } from "../../utils/formatTime";
import { Popup } from "../../components/common/ui/NotificationModal/Popup";
import CustomLoader from "../../components/common/ui/Loader";

function SharedPOD() {
  const {
    facilityDropDown,
    logHistorFirstName,
    logHistoryLastName,
    GetPodList,
  } = useSelector((x) => x.master);

  const {
    SharedPod,
    SharedPodLogReport,
    SharedPodFullLogReport,
    SharedPodAccessDetails,
  } = useSelector((x) => x.logReport);

  const { podStatusOptions } = useSelector((x) => x.dropdownOptions);

  let SharedPodSearch = { ...SharedPod };
  const [showSearchFields, setShowSearchFields] = useState(false);

  const dispatch = useDispatch();

  const [podAccessDetails, setPodAccessDetails] = useState({
    FacilityID: 0,
    InmateID: 0,
    FromDate: "",
    ToDate: "",
    PageNo: 1,
    RowCountPerPage: 10,
    SortField: "",
  });

  //Load Facility dropdown List
  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 })
    );
  }, [dispatch]);
  useEffect(() => {
    handleReset();
  }, []);

  //Pagination

  useEffect(() => {
    dispatch(logReportAction.SharedPodAccessInmateLogReport(SharedPodSearch));
  }, [SharedPodSearch.PageNo, SharedPodSearch.RowCountPerPage]);

  useEffect(() => {
    dispatch(
      logReportAction.SharedPodAccessInmateReportDetails(podAccessDetails)
    );
  }, [podAccessDetails?.PageNo, podAccessDetails?.RowCountPerPage]);

  const handleSelectChange = (selectedOption, name) => {
    // const loadGridList = () => {
    //   dispatch(logReportAction.SharedPodAccessInmateLogReport(SharedPodSearch));
    // };
    const loadGridList = () => {
      dispatch(
        logReportAction.SharedPodAccessInmateLogReport({
          ...SharedPodSearch,
          PageNo: 1,
        })
      );
      dispatch(
        logReportAction.setSharedPod({
          ...SharedPodSearch,
          PageNo: 1,
          RowCountPerPage: 10,
        })
      );
    };

    const handleFacilityID = () => {
      // Reset InmateFirstName and InmateLastName
      SharedPodSearch.InmateFirstName = "";
      SharedPodSearch.FirstNameValue = 0;
      SharedPodSearch.InmateLastName = "";
      SharedPodSearch.LastNameValue = 0;
      SharedPodSearch.PodID = 0;

      // Update FacilityID
      SharedPodSearch[name] = selectedOption?.value || 0;

      // Dispatch actions
      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: SharedPodSearch[name],
          LastName: SharedPodSearch?.InmateLastName,
        })
      );
      dispatch(
        masterActions.GetInmateLastName({
          facilityID: SharedPodSearch[name],
          firstName: SharedPodSearch?.InmateFirstName,
        })
      );
      dispatch(masterActions.GetPODList(SharedPodSearch[name]));

      // Reload grid data
      loadGridList();
    };

    const handlePod = () => {
      SharedPodSearch[name] = selectedOption?.value || 0;
      loadGridList();
    };

    const handleFirstName = () => {
      SharedPodSearch[name] = selectedOption
        ? selectedOption?.value > 0
          ? selectedOption?.label
          : ""
        : "";

      SharedPodSearch.FirstNameValue = selectedOption?.value || 0;

      dispatch(
        masterActions.GetInmateLastName({
          facilityID: SharedPodSearch.FacilityID,
          firstName: SharedPodSearch.InmateFirstName,
        })
      );

      loadGridList();
    };

    const handleLastName = () => {
      SharedPodSearch[name] = selectedOption
        ? selectedOption?.value > 0
          ? selectedOption?.label
          : ""
        : "";

      SharedPodSearch.LastNameValue = selectedOption?.value || 0;

      //Need clear the FiestName when i choose the Lastname
      SharedPodSearch.InmateFirstName = "";
      SharedPodSearch.FirstNameValue = 0;

      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: SharedPodSearch?.FacilityID,
          LastName: SharedPodSearch?.InmateLastName,
        })
      );

      loadGridList();
    };

    switch (name) {
      case "FacilityID":
        handleFacilityID();

        break;

      case "PodID":
        handlePod();
        break;

      case "InmateFirstName":
        handleFirstName();
        break;

      case "InmateLastName":
        handleLastName();
        break;

      case "SharedStatus":
        SharedPodSearch[name] =
          selectedOption?.value === 0 ? 0 : selectedOption?.value || 1;
        loadGridList();
        break;

      default:
        console.warn(`Unhandled field name: ${name}`);
    }

    //dispatch(logReportAction.setSharedPod(SharedPodSearch));
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    SharedPodSearch.InmateResidentID = value.replace(/\D/g, "");

    dispatch(logReportAction.setSharedPod(SharedPodSearch));
  };

  const handleDateChange = (value, name) => {
    const date = fDate(value);
    SharedPodSearch[name] = date;
    dispatch(logReportAction.setSharedPod(SharedPodSearch));
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;

    if (fieldName === "FromDate") {
      if (
        SharedPodSearch.ToDate &&
        new Date(value) > new Date(SharedPodSearch.ToDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "ToDate") {
      if (
        SharedPodSearch.FromDate &&
        new Date(value) < new Date(SharedPodSearch.FromDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...SharedPodSearch,
      FromDate:
        fieldName === "FromDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : SharedPodSearch.FromDate, // preserve existing value
      ToDate:
        fieldName === "ToDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : SharedPodSearch.ToDate, // preserve existing value
    };
    dispatch(logReportAction.setSharedPod(updatedParam));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (!SharedPodSearch.FacilityID) {
      dispatch(logReportAction.clearinmateAccessReportList());
      Popup({
        title: "Message",
        text: `Select any one of the Facility Code in the dropdown list`,
        icon: "info",
        confirmButtonText: "Ok",
      });
    }

    //dispatch(logReportAction.SharedPodAccessInmateLogReport(SharedPodSearch));

    dispatch(
      logReportAction.SharedPodAccessInmateLogReport({
        ...SharedPodSearch,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
    dispatch(
      logReportAction.setSharedPod({
        ...SharedPodSearch,
        PageNo: 1,
        RowCountPerPage: 10,
      })
    );
  };

  const handleReset = () => {
    dispatch(logReportAction.resetSharedPod());
  };

  //Table

  const column = [
    {
      name: "Inmate ID",
      key: "InmateResidentId",
      selector: (row) => row.InmateResidentId,
      sortable: true,
    },
    {
      name: "Inmate Name",
      key: "InmateFullName",
      selector: (row) => row.InmateFullName,
      sortable: true,
    },
    {
      name: "Facility Code",
      key: "FacilityCode",
      selector: (row) => row.FacilityCode,
      sortable: true,
    },
    {
      name: "Own POD",
      key: "OwnPodCode",
      selector: (row) => row.OwnPodCode,
      sortable: true,
    },
    {
      name: "Accessed POD Count",
      key: "AccessedSharedPodCount",
      selector: (row) => row.AccessedSharedPodCount,
      sortable: true,
    },
    {
      name: "No of Attempt",
      key: "LoginCount",
      selector: (row) => row.LoginCount,
      cell: (row) => (
        <div
          className="Common_Link_Style"
          data-bs-toggle="modal"
          data-bs-target="#Login_Details"
          onClick={() => handleLoginAttempt(row)}
        >
          {row.LoginCount}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Last Login On",
      key: "LastLoginDate",
      selector: (row) => formatDateTimeAMPM(row.LastLoginDate),
      sortable: true,
    },
    {
      name: "Status",
      key: "InmateStatus",
      selector: (row) => row.InmateStatus,
      cell: (row) => (
        <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
          <img
            title={row.InmateStatus}
            src={row.InmateStatus === "Active" ? activeIcon : inactiveIcon}
            alt={row.InmateStatus === 1 ? "Active User" : "Inactive User"}
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed inactiveIcon
          />
        </div>
      ),
      sortable: true,
      center: true,
    },
  ];

  const podAccessDetilsColumn = [
    {
      name: "POD",
      key: "PodCode",
      selector: (row) => row.PodCode,
      sortable: true,
    },
    {
      name: "Kiosk Code",
      key: "KioskCode",
      selector: (row) => row.KiosksCode,
      sortable: true,
    },
    {
      name: "Login On",
      key: "LogInDate",
      selector: (row) => formatDateTimeAMPM(row.LogInDate),
      sortable: true,
    },
    {
      name: "POD Status",
      key: "CurrentSharedStatus",
      selector: (row) => row.CurrentSharedStatus,
      cell: (row) => (
        <div className="d-flex flex-wrap justify-content-center align-items-center h-100">
          <img
            title={row.CurrentSharedStatus}
            src={
              row.CurrentSharedStatus === "ACTIVE" ? inactiveIcon : activeIcon
            }
            alt={
              row.CurrentSharedStatus === 1 ? "Active User" : "Inactive User"
            }
            style={{ width: "20px", height: "20px" }} // Adjust icon size as needed inactiveIcon
          />
        </div>
      ),
      sortable: true,
      center: true,
    },
  ];

  //Sorting
  let isSorting = false; // to restrict the pagination issue
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    isSorting = true;
    const search = { ...SharedPodSearch };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    dispatch(logReportAction.setSharedPod(search));

    dispatch(
      logReportAction.SharedPodAccessInmateLogReport({
        ...SharedPodSearch,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };

  let isModalSorting = false; // to restrict the pagination issue
  const handleSortModal = (column, sortDirection) => {
    if (!column?.key) return;
    // setSorting(true);
    isModalSorting = true;
    const search = { ...podAccessDetails };
    const newSortOrder = search.SortField.includes(column.key)
      ? search.SortField.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";

    search.SortField = `${column.key} ${newSortOrder}`;
    setPodAccessDetails(search);

    dispatch(
      logReportAction.SharedPodAccessInmateReportDetails({
        ...podAccessDetails,
        SortField: `${column.key} ${newSortOrder}`,
      })
    );
  };
  //Pagination

  const handlePageChange = (value, name) => {
    if (name === "SharedPodLogReport") {
      if (isSorting) {
        isSorting = false;
        return;
      }
      SharedPodSearch.PageNo = value;
      dispatch(logReportAction.setSharedPod(SharedPodSearch));
    } else if (name === "PopupTable") {
      if (isModalSorting) {
        isModalSorting = false;
        return;
      }
      setPodAccessDetails((prev) => ({
        ...prev,
        PageNo: value,
      }));
    }
  };

  // const handleRowPerPage = (value, name) => {
  //   if (name === "SharedPodLogReport") {
  //     SharedPodSearch.RowCountPerPage = value;
  //     dispatch(logReportAction.setSharedPod(SharedPodSearch));
  //   } else if (name === "PopupTable") {
  //     setPodAccessDetails((prev) => ({
  //       ...prev,
  //       RowCountPerPage: value,
  //     }));
  //   }
  // };

  // Call API when page changes

  const handleRowPerPage = (value, name) => {
    if (name === "SharedPodLogReport") {
      const params = { ...SharedPodSearch, RowCountPerPage: value, PageNo: 1 };
      dispatch(logReportAction.setSharedPod(params));
    } else if (name === "PopupTable") {
      setPodAccessDetails((prev) => ({
        ...prev,
        RowCountPerPage: value,
        PageNo: 1,
      }));
    }
  };

  const handleLoginAttempt = (row) => {
    // Create a parameter object based on podAccessDetails
    let param = { ...podAccessDetails };
    param.FacilityID = row.facilityID;
    param.InmateID = row.InmateID;
    param.FromDate = SharedPodSearch.FromDate;
    param.ToDate = SharedPodSearch.ToDate; // Corrected assignment for ToDate
    param.PageNo = 1;
    param.RowCountPerPage = 10;
    // Update state with the new parameter object
    setPodAccessDetails(param);

    // Dispatch the action with the updated parameter object
    dispatch(logReportAction.SharedPodAccessInmateReportDetails(param));
  };

  //excel
  useEffect(() => {
    if (SharedPodFullLogReport?.DataList?.length > 0) {
      const title = "SharedPODAccessInmateReport";
      const generateColumn = [
        "Inmate ID",
        "Inmate Name",
        "Facility Code",
        "Own POD",
        "Accessed POD Count",
        "No of Attempt",
        "Last Login On",
        "Status",
      ];

      const exportExcelData = SharedPodFullLogReport?.DataList?.map((obj) => ({
        InmateID: obj.InmateResidentId,
        InmateFullName: obj.InmateFullName,
        FacilityCode: obj.FacilityCode,
        OwnPodCode: obj.OwnPodCode,
        AccessedSharedPodCount: obj.AccessedSharedPodCount,
        LoginCount: obj.LoginCount,
        LastLoginDate: formatDateTimeAMPM(obj.LastLoginDate),
        InmateStatus: obj.InmateStatus,
      }));

      // Generate the Excel file with the transformed data

      try {
        generateXlsx(exportExcelData, generateColumn, title);
        dispatch(logReportAction.clearSharedPodFullLogReport());
      } catch (error) { }
    }
  }, [SharedPodFullLogReport]);

  if (SharedPodLogReport?.loading) {
    return <CustomLoader />;
  }

  const handleExcel = () => {
    let updatedParams = {
      ...SharedPodSearch,
      PageNo: 1,
      RowCountPerPage: SharedPodLogReport.TotalRecordCount,
      exportExcel: true,
    };

    dispatch(logReportAction.SharedPodAccessInmateLogReport(updatedParams));
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="facilityID"
                label="Facility Code"
                options={facilityDropDown}
                value={SharedPodSearch?.FacilityID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "FacilityID")
                }
                isMulti={false}
                isClearable={SharedPodSearch?.FacilityID ? true : false}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateResidentID"
                id="InmateResidentID"
                label="Inmate ID"
                value={SharedPodSearch?.InmateResidentID}
                handleChange={handleChange}
                placeholder=""
                disabled={false}
                maxLength={18}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="InmateLastName"
                label="Last Name"
                options={logHistoryLastName}
                value={SharedPodSearch?.LastNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "InmateLastName")
                }
                isMulti={false}
                isClearable={SharedPodSearch?.LastNameValue ? true : false}
                isDisabled={!SharedPodSearch.FacilityID}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="InmateFirstName"
                label="First Name"
                options={logHistorFirstName}
                value={SharedPodSearch?.FirstNameValue}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "InmateFirstName")
                }
                isMulti={false}
                isClearable={SharedPodSearch?.FirstNameValue ? true : false}
                isDisabled={!SharedPodSearch.FacilityID}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="PodID"
                label="POD"
                options={GetPodList}
                value={SharedPodSearch?.PodID}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "PodID")
                }
                isMulti={false}
                isClearable={SharedPodSearch?.PodID ? true : false}
                isDisabled={!SharedPodSearch.FacilityID}
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="SharedStatus"
                label="Inmate Status"
                options={podStatusOptions}
                value={SharedPodSearch?.SharedStatus}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "SharedStatus")
                }
                // isDisabled={SharedPodSearch.FacilityID === 0 ? true : false}
                isMulti={false}
                isClearable={SharedPodSearch?.SharedStatus !== 1}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <DateInput
              name="FromDate"
              label="From Date"
              maxDate={
                SharedPodSearch?.ToDate ? SharedPodSearch?.ToDate : new Date()
              }
              minDate={new Date(2017, 0, 1)}
              value={SharedPodSearch?.FromDate || null}
              handleChange={(date) => handleDateChange(date, "FromDate")}
              yearDropDown={true}
              // required
              isClearable={true}
              // errorMessage={errorMessage}
              handleBlur={(e) => handleDateBlur(e, "FromDate")}
            />
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <DateInput
              name="ToDate"
              label="To Date"
              minDate={SharedPodSearch?.FromDate || new Date(2017, 0, 1)}
              maxDate={new Date()}
              value={SharedPodSearch?.ToDate || null}
              handleChange={(date) => handleDateChange(date, "ToDate")}
              // required
              isClearable={true}
              // errorMessage={errorMessage}
              handleBlur={(e) => handleDateBlur(e, "ToDate")}
            />
          </div>
        </div>

        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            className="me-2"
            label="Search"
            type="submit"
            status="primary"
            icon={"search"}
            onClick={handleSearch}
          />
          <Button
            className="me-2"
            label="Reset"
            icon={"fa-solid fa-rotate-right"}
            type="button"
            status="secondary"
            onClick={handleReset}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
        {/* <div className="mb-2">
          <h2 className="form_title_uppercase text-color">
            Shared Pod Access Inmate Reports
          </h2>
        </div> */}
        <div className=" d-block d-md-none">
          <div
            className=" d-flex align-items-center justify-content-between"
            style={{ background: "transparent", cursor: "pointer" }}
            onClick={toggleInformation}
          >
            <h2 className="form_title_uppercase text-color">
              Shared Pod Access Inmate Report Search
            </h2>
            <i
              id="itagInformation"
              className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""}`}
              style={{ fontSize: "20px" }}
            ></i>
          </div>
        </div>
        {/* Mobile only (Below md breakpoint) */}
        <div className="d-block d-md-none mt-2">
          {showSearchFields && renderSearch()}
        </div>

        {/* Web only (Desktop and above) */}
        <div className="mb-3 d-none d-md-block">
          <h2 className="form_title_uppercase text-color">
            Shared Pod Access Inmate Report Search
          </h2>
        </div>
        {/* Web only (Desktop and above) */}
        <div className="d-none d-md-block">{renderSearch()}</div>
      </div>

      <div className="mt-5">
        {SharedPodSearch.FacilityID == 0 ? (
          <div className="text-center">
            <b className="table-no-data-text mt-5 fs-4 mb-5">
              Select any one of the Facility Code in the dropdown list
            </b>
          </div>
        ) : (
          <>
            {SharedPodLogReport?.DataList?.length > 0 && (
              <>
                <div className=" d-flex gap-3 align-items-center mb-2 ">
                  <div className="col-12 d-flex flex-wrap justify-content-between align-items-center resp-space">
                    <h2 className="form_title_uppercase text-color">
                      Shared Pod Access Inmate Report LIST
                    </h2>

                    {/* Right-aligned Export Button */}
                    <div>
                      <ExcelExport handleExcelExport={handleExcel} />
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-wrap align-items-center gap-3 mb-2">
                  <div className="d-flex flex-wrap align-items-center">
                    <img
                      src={activeIcon}
                      alt="Active Icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <span className="ms-2">Inmate Current</span>
                  </div>
                  <div className="d-flex flex-wrap align-items-center">
                    <img
                      src={inactiveIcon}
                      alt="Inactive Icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <span className="ms-2">Inmate Released</span>
                  </div>
                </div>
              </>
            )}

            {/* Table */}
            <Table
              columns={column}
              data={SharedPodLogReport?.DataList}
              pagination={true}
              onChangePage={(e) => handlePageChange(e, "SharedPodLogReport")} // Call API when page changes
              onChangeRowsPerPage={(e) =>
                handleRowPerPage(e, "SharedPodLogReport")
              }
              totalRowCount={SharedPodLogReport?.TotalRecordCount}
              currentPage={SharedPodSearch?.PageNo}
              paginationPerPage={SharedPodSearch?.RowCountPerPage}
              serverSideSort
              onSort={handleSort}
              sortColumn={SharedPodSearch?.SortField?.split(" ")[0]}
              sortDirection={SharedPodSearch?.SortField?.split(" ")[1]}
            />
          </>
        )}
        <CommonModal
          modalId="Login_Details"
          title="DETAILS OF SHARED POD ACCESS"
          loader={SharedPodAccessDetails?.loading}
          bodyContent={
            <>
              <div className="d-flex flex-wrap align-items-center gap-3 mb-2">
                <div className="d-flex flex-wrap align-items-center">
                  <img
                    src={activeIcon}
                    alt="Active Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <span className="ms-2">Shared</span>
                </div>
                <div className="d-flex flex-wrap align-items-center">
                  <img
                    src={inactiveIcon}
                    alt="Inactive Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                  <span className="ms-2">Unshared</span>
                </div>
              </div>
              <Table
                title={""}
                columns={podAccessDetilsColumn}
                data={SharedPodAccessDetails?.DataList || []} // Fallback to an empty array
                pagination={true}
                onChangePage={(e) => handlePageChange(e, "PopupTable")} // Call API when page changes
                onChangeRowsPerPage={(e) => handleRowPerPage(e, "PopupTable")} // Handle rows per page  change
                totalRowCount={SharedPodAccessDetails?.TotalRecordCount}
                currentPage={podAccessDetails?.PageNo}
                paginationPerPage={podAccessDetails?.RowCountPerPage}
                serverSideSort
                onSort={handleSortModal}
                sortColumn={podAccessDetails?.SortField?.split(" ")[0]}
                sortDirection={podAccessDetails?.SortField?.split(" ")[1]}
              />
            </>
          }
          footerContent={
            <button
              className="btn button-primary"
              data-bs-dismiss="modal"
            // onClick={handleCloseModal}
            >
              Close
            </button>
          }
        />
      </div>
    </div>
  );
}

export default React.memo(SharedPOD);
